export const ServerUrl = process.env.REACT_APP_REST_API_URL ?? '';
export const ImageServerUrl = process.env.REACT_APP_IMAGE_SERVER_URL ?? '';

export const getImageServerPath = (url: string | undefined): string => {
  if (!!url) {
    return (url?.startsWith('http') ? '' : ImageServerUrl) + url;
  }
  return '';
}